import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type SelectionImpressionEventParams = {
	node: Element;
	value: string;
	elementCurrentStep: number;
	elementTotalSteps: number;
};

export class SelectionImpressionEvent extends BaseEvent {
	constructor({ value, elementCurrentStep, elementTotalSteps }: SelectionImpressionEventParams) {
		super({
			eventInfo: {
				eventAction: EventAction.Impression,
				eventName: `selections - selection category impression`,
			},
			attributes: {
				componentName: 'selections',
				value,
				relatedElements: [
					{
						elementName: 'selection category',
						elementValue: value,
						elementCurrentStep: `${elementCurrentStep}`,
						elementTotalSteps: `${elementTotalSteps}`,
					},
				],
			},
		});
	}
}
